export default "__VITE_ASSET__gvXGh5lg__"